import type { FieldKey } from "./fields";
import type { EntryFilterState } from "./types";
import { filterStateParser } from "./urlState";

export const DEFAULT_STATUS = ["tracked", "reviewed"] as const;

export const DEFAULT_FILTERS: EntryFilterState = {
	status: [...DEFAULT_STATUS],
};

export function isDefaultFilters(
	filters: EntryFilterState,
	defaults: EntryFilterState = DEFAULT_FILTERS,
): boolean {
	return filterStateParser.eq(filters, defaults);
}

export function nonDefaultFields(
	filters: EntryFilterState,
	defaults: EntryFilterState = DEFAULT_FILTERS,
): Set<FieldKey> {
	const out = new Set<FieldKey>();
	if (
		!filterStateParser.eq(
			{ status: filters.status },
			{ status: defaults.status },
		)
	) {
		out.add("status");
	}
	for (const field of [
		"timekeeper",
		"application",
		"matter",
		"client",
		"billableCategory",
		"task",
		"activity",
	] as const) {
		if (
			JSON.stringify(filters[field] ?? null) !==
			JSON.stringify(defaults[field] ?? null)
		) {
			out.add(field);
		}
	}
	return out;
}
